module.exports = __webpack_public_path__ + "img/logo.6dba22b1.png";